import { devices } from "@theme/devices";
import { css, DefaultTheme, ThemedCssFunction } from "styled-components";

export const breakpoints: {
  phoneMax: ThemedCssFunction<DefaultTheme>;
  tabletMinMax: ThemedCssFunction<DefaultTheme>;
  tabletMin: ThemedCssFunction<DefaultTheme>;
  tabletMax: ThemedCssFunction<DefaultTheme>;
  laptopMinMax: ThemedCssFunction<DefaultTheme>;
  laptopMin: ThemedCssFunction<DefaultTheme>;
  laptopMax: ThemedCssFunction<DefaultTheme>;
  computerMin: ThemedCssFunction<DefaultTheme>;
} = {
  // @ts-ignore
  phoneMax: (first, ...interpolations) => {
    return css`
      @media (max-width: ${devices.phone.max}px) {
        ${css(first, ...interpolations)}
      }
    `;
  },
  // @ts-ignore
  tabletMinMax: (first, ...interpolations) => css`
    @media (min-width: ${devices.tablet.min}px) and (max-width: ${devices.tablet
        .max}px) {
      ${css(first, ...interpolations)}
    }
  `,
  // @ts-ignore
  tabletMin: (first, ...interpolations) => css`
    @media (min-width: ${devices.tablet.min}px) {
      ${css(first, ...interpolations)}
    }
  `,
  // @ts-ignore
  tabletMax: (first, ...interpolations) => css`
    @media (max-width: ${devices.tablet.max}px) {
      ${css(first, ...interpolations)}
    }
  `,
  // @ts-ignore
  laptopMinMax: (first, ...interpolations) => css`
    @media (min-width: ${devices.laptop.min}px) and (max-width: ${devices.laptop
        .max}px) {
      ${css(first, ...interpolations)}
    }
  `,
  // @ts-ignore
  laptopMin: (first, ...interpolations) => css`
    @media (min-width: ${devices.laptop.min}px) {
      ${css(first, ...interpolations)}
    }
  `,
  // @ts-ignore
  laptopMax: (first, ...interpolations) => css`
    @media (max-width: ${devices.laptop.max}px) {
      ${css(first, ...interpolations)}
    }
  `,
  // @ts-ignore
  computerMin: (first, ...interpolations) => css`
    @media (min-width: ${devices.computer.min}px) {
      ${css(first, ...interpolations)}
    }
  `,
};
